export interface ShipperSupplier {
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  shipperAccountKey: string;
  shippingServiceId: string;
  shippingServiceKey: string;
  shippingCharge: number;
}
